<template>
  <div>
    <modal-form
      v-model="show"
      size="xl"
      :key="model.Codigo"
      :show-submit="false"
      text-close="Fechar">
      <template v-slot:title>Agenda de pagamento</template>
      <template v-slot:body>
        <v-card flat class="border rounded-xl px-4 mb-4" elevation="3">
          <v-card-title>
            <v-row class="d-flex align-center justify-space-between">
              <v-col class="d-flex align-center">
                <span class="mr-2">Informações do contrato</span>
                <v-row class="d-flex align-center">
                  <v-chip class="ma-2 pl-2" :color="statusAgenda.color" small outlined>
                    <v-icon x-small class="pr-1">{{ statusAgenda.icon }}</v-icon>
                    {{ statusAgenda.text }}
                  </v-chip>
                </v-row>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-btn outlined color="primary" class="mr-4" @click="() => $api.Multiplo.GerarCCB(model.Codigo)">
                  Ver contrato
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" outlined color="primary" @click="gerarExcel($event)">
                      <v-icon>mdi mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Baixar XLS</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider class="mx-3"/>
          <v-card-text>
            <v-row class="d-flex flex-wrap">
              <v-col cols="2" class="d-flex flex-column" v-for="item in dadosProposta" :key="item.titulo">
                <div class="align-self-start flex-grow-0">
                  <v-row style="max-height: 24px;">
                    <span class="font-weight-bold">{{ item.titulo }}</span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon class="pl-1" color="#D0D5DD" v-on="on" small>ph-question</v-icon>
                      </template>
                      <span>{{ item.tooltipText }}</span>
                    </v-tooltip>
                  </v-row>
                  <v-row class="mr-5">
                    <span :align="isNumber(item.value) && 'end'" style="width: 100%;">{{ item.value }}</span>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card flat class="border rounded-xl px-4" elevation="3">
          <v-card-title>
            <v-row class="d-flex align-center justify-space-between">
              <v-col class="d-flex align-center">
                <span class="mr-4">Parcelas</span>
                <div class="d-flex align-center">
                  <v-checkbox
                    v-for="filtro in filtroParcelas"
                    :key="filtro.value"
                    :label="filtro.text"
                    class="mr-5 pa-0"
                    v-model="opcoesFiltro"
                    :value="filtro.value"
                    @change="refreshParcelas"
                    hide-details
                    dense
                  ></v-checkbox>
                </div>
              </v-col>
              <v-btn outlined color="primary" class="mr-4" @click="() => $api.Multiplo.GetBoletosAgenda(model.Codigo)">
                <v-icon class="mr-2" small>fas fa-print</v-icon>
                Imprimir boletos
              </v-btn>
              <v-btn outlined @click="enviarPorEmail" color="primary">
                <v-icon class="mr-2" small>fas fa-paper-plane</v-icon>
                Enviar por e-mail
              </v-btn>
            </v-row>
          </v-card-title>
          <v-divider class="mx-3"/>
          <v-card-text>
            <v-row>
              <v-col>
                <core-grid
                  ref="gridParcelas"
                  class="custom-table"
                  :onRead="onReadParcelas"
                  :schema="schema"
                  mobile-breakpoint="0"
                  modal
                  flat
                  hide-all-options
                  :pageSize="5">
                  <template v-slot:[`item.Status`]="{item}">
                    <div class="d-flex justify-center">
                      <v-chip small :color="statusParcela(item).color">
                        <span :style="`color: ${statusParcela(item).textColor}`">{{ statusParcela(item).text }}</span>
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:[`item.Acoes`]="{item}">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :disabled="item.Status === $aux.SituacaoParcelaEnum.Pago"
                          @click="visualizarParcela(item)"
                          icon
                          v-on="on">
                          <v-icon>mdi mdi-file-document-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizar parcela</span>
                    </v-tooltip>
                  </template>
                </core-grid>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </modal-form>
    <ModalPagamentoParcela ref="pagamento"/>
    <ModalEnvioBoletoEmail ref="modalEmail" />
  </div>
</template>

<script>
export default {
  components: {
    ModalPagamentoParcela: () => import('./ModalAgendaPagamentoParcela.vue'),
    ModalEnvioBoletoEmail: () => import('./ModalEnvioBoletoEmail.vue'),
  },
  props: {
    codigoProposta: null,
  },
  computed: {
    statusAgenda () {
      const th = this;
      return th.$api.Agenda.getSituacaoAgenda(th, th.situacaoAgenda);
    },
    statusParcela () {
      const th = this;
      return (item) => th.$api.Agenda.getSituacaoParcela(th, item);
    }
  },
  data () {
    return {
      model: {},
      show: false,
      dadosProposta: [],
      dadosParcela: [],
      exibirBoletoParcelas: [],
      schema: [
        { text: 'Nº da parcela', value: 'NroParcela', align: 'center', template: p => this.$api.UI.Format.LeftPadNumbers(p.NroParcela, 2) },
        { text: 'Data vencimento', value: 'DtVencimento', align: 'center', format: 'date' },
        { text: 'Data pagamento', value: 'DtPagamento', align: 'center', template: p => p.DtPagamento ? this.$api.UI.Format.Date(p.DtPagamento) : '-' },
        { text: 'Dias a vencer', value: 'Dias', align: 'center' },
        { text: 'Valor parcela', value: 'VlrParcela', format: 'currency' },
        { text: 'Total pago', value: 'TotalPago', format: 'currency' },
        { text: 'Juros e Mora', value: 'JurosEMora', format: 'currency' },
        { text: 'Multa', value: 'Multa', format: 'currency' },
        { text: 'Status', value: 'Status', align: 'center' },
        { text: 'Ações', value: 'Acoes', align: 'center' },
      ],
      filtroParcelas: [
        { text: 'A vencer', value: this.$aux.SituacaoParcelaEnum.AVencer },
        { text: 'Paga', value: this.$aux.SituacaoParcelaEnum.Pago },
        { text: 'Vencida', value: this.$aux.SituacaoParcelaEnum.Vencido }
      ],
      opcoesFiltro: [],
      situacaoAgenda: this.$aux.SituacaoParcelaEnum.Aberta,
    }
  },
  methods: {
    openModal (sender) {
      const th = this;
      th.model.Codigo = sender;

      th.buscaDadosProposta((dadosProposta) => {
        th.buscaDadosPagamento((dadosPagamento) => {
          th.situacaoAgenda = dadosPagamento.SituacaoAgenda;

          var pagas = 0;
          var avencer = 0;
          var vencidas = 0;
          var diasAtraso = 0;
          var multa = 0;
          var jurosMora = 0;

          dadosPagamento.Parcelas.forEach((parcela) => {
            multa += parcela.CalculoValorParcela.VlrMulta || 0
            jurosMora += parcela.CalculoValorParcela.VlrMora || 0

            switch (parcela.Situacao) {
              case th.$aux.SituacaoParcelaEnum.AVencer:
                avencer++
                break
              case th.$aux.SituacaoParcelaEnum.Vencido:
                vencidas++
                break
              case th.$aux.SituacaoParcelaEnum.Pago:
                pagas++
                break
              default:
                break
            };
          })

          diasAtraso = this.calculaDiasAtraso(dadosPagamento.Parcelas);

          const dadosPropostaHeader = [
            { titulo: 'Produto', value: dadosProposta.TipoContratoDescricao, tooltipText: 'Nome do produto de crédito contratado' },
            { titulo: 'Nº do contrato', value: th.$api.UI.Format.LeftPadNumbers(dadosProposta.CodigoProposta, 9), tooltipText: 'Número do contrato de crédito gerado' },
            { titulo: 'Data da emissão', value: th.$api.UI.Format.Date(dadosProposta.DtInclusao), tooltipText: 'Data da emissão do contrato de crédito' },
            { titulo: 'Solicitado/utilizado', value: th.$api.UI.Format.Currency(dadosProposta.VlrSolicitado), tooltipText: 'Valor contratado/utilizado na operação de crédito' },
            { titulo: 'Contratado', value: th.$api.UI.Format.Currency(dadosProposta.VlrTotalCredito), tooltipText: 'Valor total contratado' },
            { titulo: 'IOF', value: th.$api.UI.Format.Currency(dadosProposta.VlrIOF), tooltipText: 'Imposto sobre a operação financeira' },
            { titulo: 'Tarifa de cadastro', value: th.$api.UI.Format.Currency(dadosProposta.VlrTAC), tooltipText: 'Valor de tarifa atrelado à operação de crédito' },
            { titulo: 'Parcelas', value: dadosProposta.QtdeParcelas, tooltipText: 'Quantidade de parcelas selecionadas para pagamento da operação de crédito' },
            { titulo: 'Valor das parcelas', value: th.$api.UI.Format.Currency(dadosProposta.VlrParcelaCalculado), tooltipText: 'Valor das parcelas para pagamento da operação de crédito' },
            { titulo: 'Pagas', value: pagas, tooltipText: 'Quantidade de parcelas pagas do crédito contratado' },
            { titulo: 'A vencer', value: avencer, tooltipText: 'Quantidade de parcelas a vencer do crédito contratado' },
            { titulo: 'Vencidas', value: vencidas, tooltipText: 'Quantidade de parcelas vencidas do crédito contratado' },
            { titulo: 'Juros de mora', value: th.$api.UI.Format.Currency(jurosMora), tooltipText: 'Taxa aplicada sobre o valor da parcela não paga dentro do prazo' },
            { titulo: 'Juros', value: `${th.$api.UI.Format.Decimal(dadosProposta.PercJurosMensal)}%`, tooltipText: 'Taxa de juros contratada na operação de crédito' },
            { titulo: 'Multa/atraso', value: th.$api.UI.Format.Currency(multa), tooltipText: 'Cobrança de valor por atraso no pagamento da(s) parcela(s)' },
            { titulo: 'Dias de atraso', value: `${diasAtraso} ${diasAtraso === 1 ? 'dia' : 'dias'} `, tooltipText: 'Quantidade de dias da data de vencimento da parcela vencida mais antiga para a data atual' }
          ];
          th.$set(th, 'dadosProposta', dadosPropostaHeader);
          th.show = true;
        })
      })
    },
    enviarPorEmail () {
      this.$refs.modalEmail.openModal(this.model.Codigo)
    },
    buscaDadosProposta (callback) {
      const th = this;
      th.$api.Multiplo.Post('FindRecordProposta', { guidID: th.model.Codigo }).then((dadosProposta) => {
        callback(dadosProposta)
      })
    },
    buscaDadosPagamento (callback) {
      const th = this;
      const dto = {
        dto: {
          CodigoProposta: th.model.Codigo,
        },
        dtoConsultaDetalhes: {
          TrazerBoleto: true,
          TrazerAgendaDetalhada: true,
        },
        SituacaoParcela: th.opcoesFiltro,
      };
      th.$api.Multiplo.Post('AgendaRecebivelConsultarDetalhes', dto).then((dadosAgenda) => {
        callback(dadosAgenda);
      }).catch(() => {
        th.$api.UI.ShowAlert('A Agenda de Pagamento está sendo gerada, aguarde mais alguns minutos para visualizá-la');
      });
    },
    onReadParcelas: function (options, search) {
      const th = this;
      var dadosParcela = []
      th.buscaDadosPagamento((dadosAgenda) => {
        dadosAgenda.Parcelas.forEach(parcela => {
          dadosParcela.push(
            {
              NroParcela: parcela.NroParcela,
              DtVencimento: parcela.DtVencimento,
              DtPagamento: parcela.Lancamentos[0]?.DtLancamento,
              Dias: th.$api.UI.Date.DaysBetween(parcela.Lancamentos[0]?.DtLancamento || new Date(), parcela.DtVencimento),
              VlrParcela: parcela.VlrParcela,
              VlrParcelaAtualizado: parcela.CalculoValorParcela?.VlrSaldoAtualizado,
              TotalPago: parcela.VlrTotalPago,
              Mora: parcela.CalculoValorParcela?.VlrMora,
              Juros: parcela.CalculoValorParcela?.VlrJurosContrato,
              Multa: parcela.CalculoValorParcela?.VlrMulta,
              JurosEMora: parcela.CalculoValorParcela?.VlrMora + parcela.CalculoValorParcela?.VlrJurosContrato,
              Status: parcela.Situacao,
              LinhaDigitavel: parcela.Boletos[0]?.LinhaDigitavel,
              URLImpressao: parcela.Boletos[0]?.URLImpressao,
              QRCode: parcela.Boletos[0]?.QRCode,
              SituacaoBoletoRegistro: parcela.Boletos[0]?.SituacaoBoletoRegistro,
              QtdeParcelas: dadosAgenda.QtdeParcelas,
              NumeroProposta: dadosAgenda.NumeroProposta
            }
          )
        })
        th.dadosParcela = dadosParcela;
        th.exibirBoletoParcelas = dadosParcela.filter(parcela => parcela.Status === th.$aux.SituacaoParcelaEnum.AVencer || parcela.Status === th.$aux.SituacaoParcelaEnum.Vencido);
        options.success(dadosParcela);
      })
    },
    visualizarParcela (current) {
      const th = this;
      const exibirBoletoParcela = th.exibirBoletoParcelas.some(parcela => parcela.NroParcela === current.NroParcela);
      th.$refs.pagamento.openModal(current, exibirBoletoParcela);
    },
    getDadosPropostaExcel (callback) {
      const th = this;
      var excelDadosProposta = {
        labels: [],
        values: []
      }
      excelDadosProposta.labels = (th.dadosProposta.map(p => p.titulo))
      excelDadosProposta.values.push(th.dadosProposta.map(p => p.value.toString()))
      callback(excelDadosProposta)
    },
    getDadosParcelaExcel (callback) {
      const th = this;
      var excelDadosParcela = {
        labels: [],
        values: []
      }
      var dadosParcela = th.dadosParcela.map(item => {
        return {
          NroParcela: item.NroParcela,
          DtVencimento: th.$api.UI.Format.Date(item.DtVencimento) || '-',
          DtPagamento: th.$api.UI.Format.Date(item.DtPagamento) || '-',
          Dias: item.Dias,
          VlrParcela: th.$api.UI.Format.Currency(item.VlrParcela),
          TotalPago: th.$api.UI.Format.Currency(item.TotalPago) || th.$api.UI.Format.Currency(0),
          JurosEMora: th.$api.UI.Format.Currency(item.Juros + item.Mora) || th.$api.UI.Format.Currency(0),
          Multa: th.$api.UI.Format.Currency(item.Multa) || th.$api.UI.Format.Currency(0),
          Status: th.statusParcela(item).text
        }
      })
      var listaNomesGridParcelas = th.schema.map(p => p.text)
      var listaValoresGridParcelas = dadosParcela.map(p => Object.values(p))
      listaValoresGridParcelas.forEach(p => p.toString())
      excelDadosParcela.labels = listaNomesGridParcelas.filter(p => p !== 'Ações')
      excelDadosParcela.values = listaValoresGridParcelas
      callback(excelDadosParcela)
    },
    gerarExcel (e) {
      const th = this;
      th.getDadosPropostaExcel((dadosProposta) => {
        th.getDadosParcelaExcel((dadosParcela) => {
          th.$api.Exportacao.GerarExcel([dadosProposta, dadosParcela]).then(response => {
            if (th.$api.UI.PostLoadData(response, true)) {
              th.downloadXLS(response.data)
            }
          })
        })
      })
    },
    downloadXLS (file) {
      const th = this;
      var nomeArquivo = `Detalhes do Contrato - Nº ${th.dadosProposta.find(p => p.titulo === 'Nº do contrato').value}.xlsx`;
      var blob = file;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
    },
    refreshParcelas () {
      const th = this;
      th.$refs.gridParcelas.refresh();
    },
    isNumber (value) {
      return typeof value === 'string' && value.includes('R$');
    },
    calculaDiasAtraso (parcelas) {
      const th = this;
      const parcelaVencidaMaisAntiga = parcelas.find(p => p.Situacao === th.$aux.SituacaoParcelaEnum.Vencido);
      let diasAtraso = 0;
      if (parcelaVencidaMaisAntiga) {
        diasAtraso = Math.abs(th.$api.UI.Date.DaysBetween(new Date(), parcelaVencidaMaisAntiga.DtVencimento));
      }
      return diasAtraso;
    }
  }
}
</script>
